import styled from 'styled-components';

const Wrapper = styled.div`
	// background-color: #f9f9f9;
	// border-left: 5px solid #fff;
	box-sizing: border-box;
	padding: 24px 50px;
	height: 100%;
	overflow: auto;
	.header-contents-container {
		display: flex;
		flex-direction: row-reverse;
		margin: 2rem;
		padding: 2rem;
		background-color: #212121;
		color: #B9B9B9;
		justify-content: space-between;
		.header-links-container{
			display: flex;
		}
		.contact-icon {
			width: 5%;
		}
	}
	.header-title {
		color: #fff;
		font-size: 18px;
		font-weight: bold;
	}
	.help-header {
		color: #ffffff;
		font-size: 38px;
		font-weight: bold;
		padding-left: 2rem;
		border-bottom: 1px solid #A8A8B1;
	}
	.holla-support-label {
		color: #5985ff;
		margin-left: 5px;
		cursor: Pointer;
		text-decoration: underline;
	}
	.holla-support-label:hover {
		color: #3A4FFF;
		text-decoration: unset;
	}
	.help-card {
		display: flex;
		align-items: center;
		margin: 2rem;
		// margin-bottom: 34px;
		.img-box {
			min-width: 300px;
			height: 165px;
			margin-right: 50px;
			background-color: #fff;
			background-position: center;
			background-size: cover;
		}
		h3 {
			font-size: 18px;
			font-weight: bold;
		}
		.card-sub-title {
			color: #585858;
			font-size: 16px;
		}
		.card-description {
			width: 75%;
			color: #B9B9B9;
		}
		.card-link {
			font-size: 14px !important;
		}
		.sub-link {
			margin-top: 12px;
			p {
				margin: 0;
				font-size: 14px;
				a {
					padding-left: 8px;
					font-size: 14px;
				}
			}
		}
	}
	@media (max-width: 1440px) {
        .header-contents-container {
			.contact-icon {
				width: 10%;
			}
		}
	}
	@media (max-width: 900px) {
        .header-contents-container {
			display: flex;
			flex-direction: column;
			text-align: center;
			.header-links-container{
				display: flex;
				flex-direction: column;
			}
			.contact-icon {
				width: 100%;
				height: 60px;
			}
		}
	}
	@media (max-width: 550px) {
        .help-card {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin: 0rem;
			.help-card-container {
				margin: 5% 0%;
			}
	    }
    }
	// @media (max-width: 425px) {
    //     .help-card {
	// 	    display: block;
	//     }
    // }
`;

export default Wrapper;
